import { FILTER_SELECTORS_STATIC_DATA } from '../constants'

/**
 * Find filter configuration by attribute
 * @param {string} attribute - The filter attribute to find
 * @returns {Object|undefined} - The filter configuration object or undefined
 */
export const getFilterConfig = (attribute) => {
  return FILTER_SELECTORS_STATIC_DATA.find(
    (filter) => filter.attribute === attribute
  )
}
